import React from "react"

const VideoReviewsStats = ({ videoReviews }) => {
  if (!videoReviews) return null

  const totalVideos = videoReviews.length
  const approvedVideos = videoReviews.filter((video) => video.status === "approved").length
  const pendingVideos = videoReviews.filter((video) => video.status === "completed").length
  const rejectedFailedVideos = videoReviews.filter(
    (video) => video.status === "rejected" || video.status === "failed"
  ).length

  return (
    <div className="rounded-lg bg-gray-ultralight p-6">
      <h6 className="mb-4 flex items-center text-lg font-semibold text-gray-dark">
        <i className="icon-chart mr-2 text-xl text-teal" />
        Statistics
      </h6>
      <div className="grid grid-cols-4 gap-6">
        <div className="text-center">
          <div className="mb-1 text-3xl font-bold text-teal">{totalVideos}</div>
          <div className="text-sm text-gray">Total Videos</div>
        </div>
        <div className="text-center">
          <div className="mb-1 text-3xl font-bold text-green">{approvedVideos}</div>
          <div className="text-sm text-gray">Approved</div>
        </div>
        <div className="text-center">
          <div className="mb-1 text-3xl font-bold text-orange">{pendingVideos}</div>
          <div className="text-sm text-gray">Pending</div>
        </div>
        <div className="text-center">
          <div className="mb-1 text-3xl font-bold text-red">{rejectedFailedVideos}</div>
          <div className="text-sm text-gray">Rejected/Failed</div>
        </div>
      </div>
    </div>
  )
}

export default VideoReviewsStats
